import React,{useEffect} from "react";
import './SplashScreen.css';

const SplashScreen = () =>{
    useEffect(() => {
        
        var splashScreen = document.querySelector('.splash');
        splashScreen.addEventListener('click', () => {
          splashScreen.style.opacity = 0;
          setTimeout(() => {
            splashScreen.classList.add('hidden');
          }, 610);
        });
      }, []); 
  
return(
    <div>
        <div class="splash">
            <h1 class = "splash-header"><img className="logo_SplashScreen" src="../assets/logo.png" alt="logo"></img></h1>
        </div>
    </div>
)
};

export default SplashScreen;